import { ChangeDetectionStrategy, Component, effect, input, output, signal} from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputText } from 'primeng/inputtext';
import { Button } from 'primeng/button';

import { AbstractComponent } from '@spike/scaffolds';
import { Select } from "primeng/select";
import { FormsModule } from '@angular/forms';
import { ToggleButton } from 'primeng/togglebutton';
import { EntityModel } from '../../models/entity-model.model';
import { EntityModelField } from '../../models/entity-model-field.model';


@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers:[],
  imports: [CommonModule, ToggleButton, Button, InputText, Button, Select, FormsModule],
  selector: 'spike-model-form',
  templateUrl: './model-form.html'
})
export class ModelFormComponent extends AbstractComponent{
  entityModel = input.required<EntityModel>();
  onSave = output<EntityModel>();
  entityModelFields= signal<EntityModelField[]>([]);


  isFormValid=signal(true);

  fieldTypes = [
      { label: 'Testo', value: 'text' },
      { label: 'Numero', value: 'number' },
      { label: 'Data', value: 'date' },
  ];

   public updateForm = effect(() => {
    const entityModel = this.entityModel();
    if(entityModel){
      const jsonschema:any = JSON.parse(entityModel.jsonSchema);
      this.entityModelFields.set(jsonschema["model"]);
    }

  });

  public checkFields(): boolean {
    const names = this.entityModelFields().map(item => item.fieldName);
    const uniqueNames = new Set(names);
    return uniqueNames.size === names.length;
  }


  save(){
    const isValid = this.checkFields();
    this.isFormValid.set(isValid)

    if(!isValid) return;

    let entityModel: EntityModel = this.entityModel();
    entityModel.jsonSchema=JSON.stringify({"model" : this.entityModelFields()});
    this.onSave.emit(entityModel);
  }

  onAdd() {
    this.entityModelFields.set([
        ...this.entityModelFields(),
        {
          fieldId: 0,
          fieldName: 'nuovo',
          fieldType: 'text',
          required: false
          }
    ]);    
  }

  onDelete(index:number){
    this.entityModelFields().splice(index,1)
    this.entityModelFields.set([
        ...this.entityModelFields(),
    ]);    
  }

 
}